module.exports = __webpack_public_path__ + "static/media/chat-black-icon.12c1e338.svg";